export default __webpack_public_path__ + "static/assets/med_pill_square_in_L1_solid_x_01_f_mask.4ee55492.png";